export enum ContentCustomWidgetsTypes {
  UpcomingEvents = "UpcomingEvents",
  Menu = "Menu",
  Breakfast = "Breakfast",
  Lunch = "Lunch",
  Dinner = "Dinner",
  MonthlyCalendar = "MonthlyCalendar",
  WeeklyCalendar = "WeeklyCalendar",
  DailyCalendar = "DailyCalendar",
  ThisWeeksBirthday = "ThisWeeksBirthday",
  LastWeeksEvents = "LastWeeksEvents"
}